import React from 'react';

import { MainLayout, TopContent, MainContent, Box, Content, BristleBrush, GrassButton } from './styled';
import { WorkshopCode } from './workshop-code';
import { observer } from 'mobx-react-lite';
import { useStore } from '../store';
import { useSkin } from '../styles/skins';

export const WorkshopSelect = observer(() => {
  const store = useStore();
  const { currentSkin } = useSkin()

  // Check if there is more than one room in the workshop
  const multipleRooms = store.workshops[store.workshopCode]?.rooms.length > 1;

  return (
    <MainLayout>
      <TopContent>
        <h2>Please enter your workshop code</h2>
      </TopContent>

      <MainContent>
        <Content>
          <Box flex column height="100%">
            <Box expanded>
              <WorkshopCode />
              {currentSkin === 'default' && (
                <>
                  <GrassButton/>
                  <BristleBrush opacity="0.5" />
                </>
              )}
            </Box>
            {multipleRooms && (
              <Box mt="2rem">
                <p>There are multiple rooms available in this workshop. Please select one to join.</p>
              </Box>
            )}
          </Box>
        </Content>
      </MainContent>
    </MainLayout>
  );
});
